import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './accordion.component.scss';
import * as $ from 'jquery';
var Accordion = /** @class */ (function (_super) {
    tslib_1.__extends(Accordion, _super);
    function Accordion(element) {
        return _super.call(this, element) || this;
    }
    Accordion.prototype.init = function () {
        this.accordionTriggers = Array.from(this.element.querySelectorAll('.js-accordion-trigger'));
        this.collapseTriggers = Array.from(this.element.querySelectorAll('.js-collapse-trigger'));
    };
    Accordion.prototype.bindEvents = function () {
        var _this = this;
        if (this.accordionTriggers) {
            this.accordionTriggers.map(function (item) { return item.addEventListener('click', function (event) {
                _this.toggleAccordions(event);
            }); });
        }
        if (this.collapseTriggers) {
            this.collapseTriggers.map(function (item) { return item.addEventListener('click', function (event) {
                _this.toggleCollapses(event);
            }); });
        }
    };
    Accordion.prototype.toggleAccordions = function (event) {
        var _target = event.target;
        var _selected = _target.closest('.js-accordion-trigger');
        if (_selected.classList.contains('accordion__item--open')) {
            this.closeAccordion();
        }
        else {
            this.closeAccordion();
            this.openAccordion(event);
        }
    };
    Accordion.prototype.toggleCollapses = function (event) {
        var _target = event.target;
        var _parent = _target.closest('.accordion--collapse');
        var _container = _parent.querySelector('.accordion--collapse__container');
        var _containerInner = _container.querySelector('.accordion--collapse__container--inner');
        var _varInnerHeight = _containerInner.offsetHeight;
        if (_parent.classList.contains('accordion--collapse__opened')) {
            _container.style.height = "0px";
            setTimeout(function () {
                _parent.classList.remove('accordion--collapse__opened');
            }, 300);
        }
        else {
            _container.style.height = _varInnerHeight + "px";
            _parent.classList.add('accordion--collapse__opened');
        }
    };
    Accordion.prototype.closeAccordion = function () {
        var _activeAccordionTrigger = Array.from(this.element.querySelectorAll('.accordion__item--open'));
        var _activeAccordion = Array.from(this.element.querySelectorAll('.accordion__item-content--open'));
        _activeAccordionTrigger.map(function (_elem) {
            _elem.classList.remove('accordion__item--open');
            _elem.classList.add('accordion__item--closed');
        });
        _activeAccordion.map(function (_elemContent) {
            _elemContent.classList.remove('accordion__item-content--open');
            _elemContent.classList.add('accordion__item-content--closed');
        });
    };
    Accordion.prototype.openAccordion = function (event) {
        this.stopVideos();
        var _target = event.target;
        var _selectedParent = _target.closest('.js-accordion-trigger');
        setTimeout(function () {
            var _selected = _selectedParent.parentElement.querySelector('.accordion__item--closed');
            var _selectedContent = _selectedParent.parentElement.querySelector('.accordion__item-content--closed');
            _selected.classList.remove('accordion__item--closed');
            _selected.classList.add('accordion__item--open');
            _selectedContent.classList.remove('accordion__item-content--closed');
            _selectedContent.classList.add('accordion__item-content--open');
            if (document.querySelector('.cookie-policy')) {
                if (document.querySelector('.cookie-policy').classList.contains('cookie-policy--hidden') && document.querySelector('.cookie-policy').classList.contains('cookie-policy--closed')) {
                    if (document.querySelector('.header').classList.contains('header--sticky')) {
                        $('html,body').animate({
                            scrollTop: $(_selected).offset().top - 144
                        }, 'slow');
                    }
                    else {
                        $('html,body').animate({
                            scrollTop: $(_selected).offset().top - 274
                        }, 'slow');
                    }
                }
                else {
                    if (document.querySelector('.cookie-policy').classList.contains('cookie-policy--open')) {
                        if (document.querySelector('.header').classList.contains('header--sticky')) {
                            $('html,body').animate({
                                scrollTop: $(_selected).offset().top - 144
                            }, 'slow');
                        }
                        else {
                            $('html,body').animate({
                                scrollTop: $(_selected).offset().top - 350
                            }, 'slow');
                        }
                    }
                    else {
                        if (document.querySelector('.header').classList.contains('header--sticky')) {
                            $('html,body').animate({
                                scrollTop: $(_selected).offset().top - 65
                            }, 'slow');
                        }
                        else {
                            $('html,body').animate({
                                scrollTop: $(_selected).offset().top - 195
                            }, 'slow');
                        }
                    }
                }
            }
            else {
                $('html,body').animate({
                    scrollTop: $(_selected).offset().top - 144
                }, 'slow');
            }
        }, 400);
    };
    Accordion.prototype.stopVideos = function () {
        var videosVidavee = Array.from(this.element.querySelectorAll('video'));
        var videosYoutube = Array.from(this.element.querySelectorAll('#video__external'));
        videosVidavee.map(function (video) {
            if (video.player) {
                video.player.pause();
            }
        });
        videosYoutube.map(function (video) {
            //this.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
            video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
            console.log(video);
        });
    };
    return Accordion;
}(Base));
export { Accordion };



//////////////////
// WEBPACK FOOTER
// ./components/accordion/accordion.component.ts
// module id = 26
// module chunks = 0